import { useMemo } from "react"
import { useAppSelector } from "@/redux/hooks.ts"

export const useAuth = () => {
  const token = useAppSelector((state) => state.auth.token)
  const farmId = useAppSelector((state) => state.auth.farmId)

  return useMemo(() => ({ token, farmId }), [token, farmId])
}
